var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"lottieContainer",staticClass:"lottie-icon",style:({
    width: _vm.sizeNumber + 'px',
    height: _vm.sizeNumber + 'px'
  })})}
var staticRenderFns = []

export { render, staticRenderFns }